import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

console.log('🔍 [Frontend Supabase] Verificando variáveis de ambiente:', {
  supabaseUrl: supabaseUrl ? 'configurada' : 'ausente',
  supabaseAnonKey: supabaseAnonKey ? 'configurada' : 'ausente'
});

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('❌ [Frontend Supabase] Variáveis de ambiente obrigatórias não encontradas');
  console.error('❌ [Frontend Supabase] Configure VITE_SUPABASE_URL e VITE_SUPABASE_ANON_KEY no arquivo .env');
  throw new Error('Missing Supabase environment variables');
}

// Configurações básicas do Supabase para frontend
const supabaseOptions = {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
};

// Cliente público para o frontend
export const supabase = createClient(supabaseUrl, supabaseAnonKey, supabaseOptions);

console.log('✅ [Frontend Supabase] Cliente Supabase inicializado:', {
  supabaseType: typeof supabase,
  supabaseFromMethod: typeof supabase.from
});

export default supabase;
